module.exports = __webpack_public_path__ + "img/apple-crisp.58f4c022.jpg";